export const EV_CHARGER_BASE_PATH = `/ev-chargers`;
export const RoutesList = {
  LANDING_PAGE: '/',
  BEFORE_YOU_START: EV_CHARGER_BASE_PATH,
  IS_HAZARDOUS: EV_CHARGER_BASE_PATH + '/hazardous-or-has-caused-injury',
  PROVIDER_SELECTION: EV_CHARGER_BASE_PATH + '/provider-selection',
  EV_CHARGER_UPLOAD_PHOTO: EV_CHARGER_BASE_PATH + '/upload-photo',
  CALL_US: EV_CHARGER_BASE_PATH + '/call-us',
  MAP_LOCATION: EV_CHARGER_BASE_PATH + '/map-location',
  ISSUE: EV_CHARGER_BASE_PATH + '/issue',
  TELL_US_MORE: EV_CHARGER_BASE_PATH + '/tell-us-more',
  EMAIL_CONFIRMATION: EV_CHARGER_BASE_PATH + '/email-confirmation',
  YOUR_DETAILS: EV_CHARGER_BASE_PATH + '/your-details',
  CONFIRMATION: EV_CHARGER_BASE_PATH + '/confirmation',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Provider',
    urlPaths: [RoutesList.PROVIDER_SELECTION],
  },
  {
    label: 'Issue details',
    urlPaths: [
      RoutesList.EV_CHARGER_UPLOAD_PHOTO,
      RoutesList.ISSUE,
      RoutesList.TELL_US_MORE,
      RoutesList.EMAIL_CONFIRMATION,
      RoutesList.MAP_LOCATION,
    ],
  },
  {
    label: 'Your details',
    urlPaths: [RoutesList.YOUR_DETAILS],
  },
];
